<template>
  <div class="alert text-center" role="alert">
    <svgIcon icon-holder-class="icon-warning" icon-id="icon-warning" />
    {{ errorText }}
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  errorCode: {
    type: [String, Number],
    default: '',
  },
  extraErrorData: {
    type: Object,
    default: () => ({}),
  },
})

const errorText = computed(() => {
  const text = t(`error.form.${props.errorCode}`, props.extraErrorData)
  if (text.indexOf('error.form') === 0) {
    return `${t('error.500')} ( code: ${props.errorCode} )`
  }
  return text
})
</script>

<style lang="less" scoped>
.alert {
  padding: 12px 16px;
  margin-top: 20px;
  background-color: var(--alert-c);
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
}
@media (max-width: 740px) {
  .alert {
    margin-bottom: 0;
  }
}
</style>
